<wide-dialog-wrapper
  [backgroundColor]="'#9FC5E8'"
  [dialogTitle]="'Manage Budget Costs Snapshot'"
  [disabled]="false"
  [deleteTitle]="'Delete'"
  [deleteText]="deleteText"
  [delete]="true"
  [successLabel]="'CLOSE'"
  (onSubmit)="exit()"
  (onDelete)="delete()"
>
  <div class="header">
    <h5 class="name">{{ data.info.name }} </h5>
    <div style="flex:1"></div>
    <h5 class="time">{{ data.info.timestamp | date:'h:mma, EEE d MMM'}}</h5>
  </div>
  <div *ngIf="loading">Loading snapshot...</div>
  <budget-totals-strip *ngIf="!!budget"
    [discount]="budget.costsDiscount"
    [fees]="budget.costsFees"
    [readOnly]="true"
    [subtotal]="budget.costsSubtotal"
    [tax]="budget.costsTax"
    [total]="budget.totalCosts"
    [currency]="budget.currency"
  ></budget-totals-strip>
  <ng-container *ngFor="let costId of budget?.costIds">
    <ng-container *ngIf="budget && budget.sections[costId] as section">
      <hr/>
      <budget-section *ngIf="!!sectionGridDatas[section.id] && !!scheduleGridDatas[section.id]"
        [section]="section"
        [budgetCurrency]="budget.currency"
        [readOnly]="true"
        [isRevenue]="false"
        [gridData]="sectionGridDatas[section.id]"
        [scheduleGridData]="scheduleGridDatas[section.id]"
      ></budget-section>
    </ng-container>
  </ng-container>
</wide-dialog-wrapper>